import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import PreLoader from "./components/PreLoader/Preloader";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { useCikContext } from "./Context/CentralIndustrisContaxtProvider";

function App() {
  const { preloaderstatus, setPreloaderStatus } = useCikContext();

  useEffect(() => {
    Aos.init({});
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPreloaderStatus(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [setPreloaderStatus]);

  if (preloaderstatus) {
    return <PreLoader />;
  }

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </>
  );
}

export default App;
